import React from 'react';
export const templateList = [
  {
    id: 1,
    technology: 'Java',
    experience: '2 years',
    data: '<div>\
  <h2>Java Developer Role</h2>\
  <p>Experience: 2 years</p>\
  <p>We are looking for a skilled Java Developer to join our team. The ideal candidate will have a passion for technology and problem-solving, with the ability to develop high-quality software solutions.</p>\
</div>\
<div>\
  <h3>Responsibilities</h3>\
  <ul>\
    <li>Develop, test, and maintain Java applications.</li>\
    <li>Collaborate with cross-functional teams to design scalable solutions.</li>\
    <li>Analyze and resolve technical issues.</li>\
    <li>Write clean, efficient, and maintainable code.</li>\
  </ul>\
  <h3>Requirements</h3>\
  <ul>\
    <li>2 years of experience in Java development.</li>\
    <li>Strong understanding of object-oriented programming.</li>\
    <li>Experience with frameworks such as Spring or Hibernate.</li>\
    <li>Knowledge of databases like MySQL or PostgreSQL.</li>\
    <li>Excellent problem-solving and communication skills.</li>\
  </ul>\
</div>'
  },
  {
    id: 2,
    technology: 'Python',
    experience: '4 years',
    data: '<div>\
    <h2>Python Developer</h2>\
    <p>Role: Python Developer</p>\
    <p>Experience: 4 years</p>\
</div>\
<div>\
    <h3>Key Responsibilities</h3>\
    <ul>\
        <li>Develop and maintain Python-based applications.</li>\
        <li>Collaborate with cross-functional teams to define and implement features.</li>\
        <li>Ensure code quality through testing and code reviews.</li>\
        <li>Optimize application performance and scalability.</li>\
    </ul>\
</div>'
  },
  {
    id: 3,
    technology: 'Java-React Fullstack Developer',
    experience: '2-4 years',
    data: '<div >\
    <h1 >Java-React Fullstack Developer</h1>\
    <p >4 years of experience in designing, developing, and maintaining full-stack applications using Java and React.</p>\
    <ul >\
        <li>Proficient in developing RESTful APIs using Spring Boot.</li>\
        <li>Experience with state management tools like Redux and Context API.</li>\
        <li>Skilled in implementing responsive designs using HTML, CSS, and Tailwind CSS.</li>\
        <li>Proficient in database design and management (SQL/NoSQL).</li>\
    </ul>\
</div>\
<div>\
    <h2>Key Skills</h2>\
    <ul>\
        <li>Java, Spring Boot, Hibernate</li>\
        <li>React, Redux, Context API</li>\
        <li>HTML, CSS, JavaScript, Tailwind CSS</li>\
        <li>PostgreSQL, MongoDB</li>\
        <li>CI/CD, Docker, Kubernetes</li>\
    </ul>\
    <h2>Notable Projects</h2>\
    <ul>\
        <li><strong>Project Management Tool:</strong> Developed a full-stack application to manage projects using Java and React.</li>\
        <li><strong>E-commerce Platform:</strong> Built an interactive, responsive e-commerce site with React and integrated a Java-based backend.</li>\
    </ul>\
</div>\
'
  },
  {
    id: 4,
    technology: 'AWS',
    experience: '2-4 years',
    data: '<div>\
  <div>\
    <h2>AWS Role</h2>\
    <p>Experience: 2-4 years</p>\
    <ul>\
      <li><strong>Position:</strong> AWS Developer</li>\
      <li><strong>Location:</strong> Remote / On-site</li>\
      <li><strong>Key Skills:</strong> EC2, S3, Lambda, CloudFormation, IAM</li>\
    </ul>\
  </div>\
  <div>\
    <h3>Responsibilities</h3>\
    <ul>\
      <li>Design and implement scalable AWS solutions.</li>\
      <li>Manage cloud infrastructure and deployments.</li>\
      <li>Ensure security and compliance in AWS environments.</li>\
      <li>Troubleshoot and optimize performance.</li>\
    </ul>\
  </div>\
</div>\
'
  }
];
